import React from 'react'
import Lottie from 'react-lottie'
import { GatsbyImage } from 'gatsby-plugin-image'
import { prepareData } from 'utils/googleData'

/* i18next-extract-disable-next-line */
const LazyReady = ({
    data,
    placeholder,
    renderLottie,
}: {
    data: any
    placeholder: React.ReactElement
    renderLottie?: boolean | string
}) => {
    const shouldRenderLottie = renderLottie !== false && renderLottie !== 'false'
    return shouldRenderLottie && data ? (
        <Lottie
            options={{
                loop: true,
                autoplay: true,
                animationData: data,
            }}
        />
    ) : (
        placeholder
    )
}

export const AboutHero = (props) => {
    const {
        enable,
        title,
        subtitle,
        renderLottie,
        description,
        cta,
        direction,
        style,
        gatsbyImage,
        animationData,
        animationData2,
        animationData3,
        animationData4,
        gatsbyImage2,
        gatsbyImage3,
        gatsbyImage4,
    } = prepareData({ props })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const [ready1Data, setReady1Data] = React.useState<any | null>(null)
    const [ready2Data, setReady2Data] = React.useState<any | null>(null)
    const [ready3Data, setReady3Data] = React.useState<any | null>(null)
    const [ready4Data, setReady4Data] = React.useState<any | null>(null)
    React.useEffect(() => {
        import('../../../../static/animations/salesreready.json').then((data) => setReady1Data(data.default))
        import('../../../../static/animations/about-ready-2.json').then((data) => setReady2Data(data.default))
        import('../../../../static/animations/about-ready-3.json').then((data) => setReady3Data(data.default))
        import('../../../../static/animations/about-ready-4.json').then((data) => setReady4Data(data.default))
    }, [])

    return (
        <>
            <header id="our-story" className="px-4 pb-4 md:px-12 md:pb-8">
                <h1
                    className="mb-4 text-center text-4xl leading-none md:text-6xl"
                    dangerouslySetInnerHTML={{ __html: title }}
                ></h1>
                <h3 className="text-center font-semibold opacity-60">
                    <p className="mb-0 pb-0 text-xl">{subtitle}</p>
                </h3>
            </header>
            {/* <Animations {ready1Data:ready1Data,ready2Data: ready2Data,ready3Data,ready4Data}/> */}
            <div className="mx-auto flex max-w-screen-xl flex-col items-center justify-center gap-4 px-4 pb-12 md:flex-row md:gap-16 md:px-8">
                <div className="flex items-center justify-between">
                    <div className="">
                        <LazyReady
                            data={ready1Data}
                            renderLottie={renderLottie}
                            placeholder={<GatsbyImage alt={title} image={gatsbyImage} placeholder="blurred" />}
                        />
                    </div>
                    <div className="">
                        <LazyReady
                            data={ready2Data}
                            renderLottie={renderLottie}
                            placeholder={<GatsbyImage alt={title} image={gatsbyImage2} placeholder="blurred" />}
                        />
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <div className="">
                        <LazyReady
                            data={ready3Data}
                            renderLottie={renderLottie}
                            placeholder={<GatsbyImage alt={title} image={gatsbyImage3} placeholder="blurred" />}
                        />
                    </div>
                    <div className="">
                        <LazyReady
                            data={ready4Data}
                            renderLottie={renderLottie}
                            placeholder={<GatsbyImage alt={title} image={gatsbyImage4} placeholder="blurred" />}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
